var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',{ref:"container",attrs:{"isLoading":_vm.loading}},[_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"left"}},_vm._l((_vm.leaders),function(leader){return _c('el-tab-pane',{key:leader.id,attrs:{"label":leader.name + '组'}},[_c('WardGroupQueue',{attrs:{"data":leader},on:{"reload":_vm.loadData}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }